const CustomersSvg = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            {/* Background User */}
            <circle cx="15" cy="8" r="3" fill="currentColor" opacity="0.3" />
            <path
                d="M10 17.5C10 15.567 11.567 14 13.5 14H16.5C18.433 14 20 15.567 20 17.5V20H10V17.5Z"
                fill="currentColor"
                opacity="0.3"
            />

            {/* Foreground User */}
            <circle cx="8" cy="7" r="4" fill="currentColor" />
            <path
                d="M3 17C3 14.7909 4.79086 13 7 13H11C13.2091 13 15 14.7909 15 17V21H3V17Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default CustomersSvg;
